// @flow

import * as React from "react";
import { useSelector } from "react-redux";
import actions from "../actions/index.js";

import Config from "../constants/Config";
import AccountContent from "./AccountContent.js";
import NotFound from "./NotFound.js";
import usePageFromStore from "../hooks/usePageFromStore.js";

const getUserEAPTierUrl = (eapPages, eapLevel) => {
    let eapTierPage;
    if (eapPages && eapLevel) {
        Object.keys(eapPages).forEach(eapPageKey => {
            // set tier page
            if (eapPages[eapPageKey].name === eapLevel) {
                eapTierPage = eapPages[eapPageKey].url;
            }
        });
    }

    return eapTierPage;
};

const EAPBenefits = (props: PropsType): React.Node => {
    const { profile } = useSelector((state: any): boolean => state.user);
    const { eap_pages } = useSelector((state: any): boolean => state.options);

    const tierPage =
        eap_pages && profile.elite_level
            ? getUserEAPTierUrl(eap_pages, profile.elite_level.name)
            : null;

    const { page } = usePageFromStore(tierPage);
    const breadcrumbs = [
        {
            title: "EAP",
            url: Config.routes.eapLanding,
            // url: eap_pages.landing.url,
        },
        {
            title: "Your Scholarship",
        },
    ];

    if (page && page.url) {
        return <AccountContent page={page} customBreadcrumbs={breadcrumbs} />;
    } else {
        return <NotFound />;
    }
};

EAPBenefits.preload = ({ location, passed: { store } }: any): Promise<any> => {
    const { profile } = store.getState().user;
    const { eap_pages } = store.getState().options;

    const tierPage =
        eap_pages && profile.elite_level
            ? getUserEAPTierUrl(eap_pages, profile.elite_level.name)
            : null;

    if (tierPage) {
        return Promise.all([store.dispatch(actions.fetchPage(tierPage))]);
    } else {
        return Promise.all([]);
    }
};

export default EAPBenefits;
